import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { Toaster } from 'react-hot-toast';

// Minimal error fallback
const ErrorFallback = () => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    minHeight: '100vh',
    background: '#1a1a1a',
    color: 'white',
    padding: '20px',
    textAlign: 'center'
  }}>
    <h1>StreamerWarZ</h1>
    <p>We're experiencing technical difficulties. Please try again later.</p>
    <a 
      href="/" 
      style={{ 
        display: 'inline-block',
        padding: '10px 20px', 
        marginTop: '20px',
        background: '#2196f3', 
        color: 'white', 
        textDecoration: 'none',
        borderRadius: '4px'
      }}
    >
      Refresh
    </a>
  </div>
);

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    console.error('Root element not found. Make sure there is an element with id "root" in your HTML.');
    return;
  }
  
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <Toaster 
          position="bottom-right"
          toastOptions={{
            className: '',
            duration: 5000,
            style: {
              background: '#333',
              color: '#fff',
            },
            success: {
              duration: 3000,
              theme: {
                primary: 'green',
                secondary: 'black',
              },
            },
          }}
        />
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Failed to render app:', error);
    // Fall back to basic rendering in case of errors
    const fallbackRoot = ReactDOM.createRoot(rootElement);
    fallbackRoot.render(<ErrorFallback />);
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals(); 